
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[name]/[slug]",
      function () {
        return require("private-next-pages/guides/[name]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/[name]/[slug]"])
      });
    }
  